import { fade } from '@material-ui/core/styles/colorManipulator';
/**
 * Style of data-display component cat. consists of
 * - progressSyles
 * - dialogStyles,
 * - snackBarStyles,
 * - backdropStyles,
 * & etc.
 */

export const backdropStyles = (theme) => ({
  backdropStyle: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#000080',
    backgroundColor: fade('#A9A9A9', 0.4),
  },
  // https://stackoverflow.com/questions/60931522/how-to-add-backdrop-that-overlays-single-component-such-as-paper-rather-than-ent
  innerBackdropStyle: {
    zIndex: 1,
    backgroundColor: fade('#A9A9A9', 0.4),
    position: "absolute",
  },
  circularProgressLoadStyle: {
    color: '#989898',
    marginRight: 4,
    marginLeft: -4,
  },
});

// https://material-ui.com/customization/z-index/ (material-ui z-index)